import React from "react";
import classes from "./ShifuFooter.module.css";

import shifu_footer from "../assets/shifu_footer.png";
import ins_icon from "../assets/ins_icon.svg";
import fb_icon from "../assets/fb_icon.svg";
import youtube from "../assets/youtube_icon.svg";
import arrow_iconsss from "../assets/arrow_iconsss.svg";
import copyright_icon from "../assets/copyright_icon.svg";

const Footer = () => {
  const handleCalendarOpen = () => {
    window.open(
      "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1EsNWvkXLWEC7fLwfd3A-uAfp6sByldbajvPT-0bY4YoXBybJ-kQi9Uh7eXRdZ1RLp9V1k9TeN",
      "_blank",
    );
  };

  return (
    <div className={classes.footer}>
      <div className={classes.footerContainer}>
        <div className={classes.leftSection}>
          <img src={shifu_footer} alt="Shifu Logo" className={classes.logo} />
          <p className={classes.description}>
            Shifu: The AI coach that personalizes learning for every employee,
            and superpowers every L&D team
          </p>
          <div className={classes.socialIcon}>
            <a
              href="https://www.instagram.com/setuschool/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ins_icon} alt="Instagram" />
            </a>

            <a
              href="https://www.facebook.com/setuailearning?rdid=n8UO8bcgCP5W8fFD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BVAmSpYrx%2F#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fb_icon} alt="Facebook" />
            </a>

            <a
              href="https://www.youtube.com/@setuschool"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={youtube} alt="YouTube" />
            </a>
          </div>
        </div>

        <div className={classes.rightSection}>
          {/* <div className={classes.column}>
            <h4 className={classes.legal}>LEGAL</h4>
            <p className={classes.privacy}>Privacy Policy</p>
            <p className={classes.terms}>Terms of Service</p>
          </div> */}

          <div className={classes.column}>
            <h4 className={classes.contact}>CONTACT</h4>
            <p className={classes.arrow_iconsss} onClick={handleCalendarOpen}>
              Schedule Demo <img src={arrow_iconsss} alt="arrow_iconsss" />
            </p>
          </div>

          {/* <div className={classes.column}>
            <h4 className={classes.resourece}>RESOURCES</h4>
            <p className={classes.case}>Case Studies</p>
          </div> */}
        </div>
      </div>

      <div className={classes.botton}>
        <p className={classes.copyright_icon}>
          <img src={copyright_icon} alt="" />
          2026 Setu School.
        </p>
      </div>
    </div>
  );
};

export default Footer;
